import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class BookingSchedulerQueryFilter extends QueryFilter{
    organizationId: string;
    simulatorId: string;
    timeZone: string;
    startDate: string;
    endDate: string;
}